module.exports = __webpack_public_path__ + "static/media/BlackStar13_1_t.afdb07fe.jpg";